<template>
  <div class="playlist">
    <div class="playlist__header">
      <div>partido</div>
      <div>marcador</div>
      <div>fecha</div>
    </div>
    <div v-if="playlist.plays && playlist.plays.length" class="playlist__games">
      <BCollapse
        v-for="(game, index) of currentPlayerQueueByGames"
        animation="slide"
        :id="`game-${index}`"
        :key="index"
        :open="currentGameIndex === index"
        :aria-id="'ariaId' + index"
        @open="onGameOpen(game, index)"
        @close="onGameClose(index)"
      >
        <template #trigger="props">
          <div
            class="playlist__games__game-header"
            :class="{ 'game-active': currentGameIndex === index }"
            role="button"
            :aria-controls="'ariaIdT' + index"
            :aria-expanded="props.open"
          >
            <div class="playlist__games__game-header__content">
              <div class="icon">
                <img
                  :src="
                    `https://golstatsimages.blob.core.windows.net/todoelfut/icn_${
                      currentGameExpandedIndex === game.gameIndex ? 'colapsar' : 'desplegar'
                    }.svg`
                  "
                />
              </div>
              <div class="teams">
                <span>{{ windowWidth > 480 ? game.homeTeam.name : game.homeTeam.acronym }}</span>
                <span class="vs"> VS </span>
                <span>{{ windowWidth > 480 ? game.awayTeam.name : game.awayTeam.acronym }}</span>
              </div>
              <div class="score">{{ `( ${game.score[0]} - ${game.score[1]} )` }}</div>
              <div class="date">
                {{
                  game.date
                    .split('-')
                    .reverse()
                    .join('/')
                }}
              </div>
            </div>
          </div>
        </template>
        <div class="playlist__games__game__plays">
          <div
            v-for="(play, index) of game.plays"
            :key="play.dateTimeMillis + index"
            class="playlist__games__game__plays__play"
            :class="{ active: play.index === playlistIndex }"
            @click="onPlayClick(play.index)"
          >
            <div class="play-icon">
              <img
                :src="
                  `https://golstatsimages.blob.core.windows.net/todoelfut/icn_play_${
                    play.index === playlistIndex ? 'green' : 'grey'
                  }.svg`
                "
              />
            </div>
            <div class="play-time-start">
              {{ getStartMinutes(play.momentOfPlay.split('.')[0]) }}
            </div>
            <div class="play-info">
              {{ `${getCategoryFormat(play.mainCategory.name)} - ${play.player.shortName}` }}
            </div>
            <div class="play-is-favorite" @click.stop="openConfirmDelete(play, game, index)">
              <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_delete_video.svg" />
            </div>
          </div>
        </div>
      </BCollapse>
    </div>
    <ConfirmDeleteInPlaylist
      question="¿Estás seguro que deseas eliminar el video de la playlist?"
      title="Eliminar video"
      :showModalConfirm="showConfirmPlaylist"
      @onConfirmPlaylist="confirmModalPlaylistConfirm"
      @onCancelPlaylist="closeModalPlaylistConfirm"
    />
  </div>
</template>

<script>
import axios from 'axios';
import EventBus from '@/utils/event-bus';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { getPlayContentIndex } from '@/data/media-player-play-indexes';
const playIndex = getPlayContentIndex();

export default {
  name: 'MyPlaylistList',
  components: {
    BCollapse: async () => {
      const { BCollapse } = await import('buefy/dist/esm/collapse');
      return BCollapse;
    },
    ConfirmDeleteInPlaylist: () => import('@/components/Modals/ConfirmDeleteInPlaylist'),
  },
  props: {
    playlist: {
      type: Object,
      default: () => {},
    },
    playlistId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentGameIndex: 0,
      currentGameExpanded: null,
      currentGameExpandedIndex: 0,
      showConfirmPlaylist: false,
      playIdToDelete: '',
      gameAux: null,
      indexAux: -1,
    };
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapState('loginGeneral', ['user']),
    ...mapState('mediaModal', ['modalInitialState', 'playlistIndex', 'advancedFilter', 'currentPlayerQueue']),
    ...mapGetters('mediaModal', ['currentPlayerQueueByGames', 'getModalSectionSelected']),
    playlistTitle() {
      const mainSections = ['Goles', 'Jugadas Relevantes'];
      return this.getModalSectionSelected === 2 && this.advancedFilter.playListTitle
        ? this.advancedFilter.playListTitle
        : this.modalInitialState.advancedFilter &&
          this.modalInitialState.advancedFilter.playListTitle &&
          this.getModalSectionSelected === this.modalInitialState.mainSectionType - 1
        ? this.modalInitialState.advancedFilter.playListTitle
        : this.getModalSectionSelected === 0 || this.getModalSectionSelected === 1
        ? mainSections[this.getModalSectionSelected]
        : '';
    },
  },
  watch: {
    currentPlayerQueueByGames(newValue) {
      if (newValue && newValue.length) {
        this.currentGameExpanded = newValue[0];
        this.currentGameExpandedIndex = 0;
      } else {
        this.currentGameExpanded = null;
      }
    },
    playlistIndex(newValue) {
      let gameIndex = 0;
      const game = this.currentPlayerQueueByGames.find((game, index) => {
        gameIndex = index;
        return newValue >= game.initialPlayIndex && newValue <= game.finalPlayIndex;
      });
      if (game) {
        let collapseElement = null;
        if (this.currentGameExpanded && this.currentGameExpanded.id !== game.id) {
          this.currentPlayerQueueByGames.forEach(listGame => {
            listGame.isExpanded = false;
          });
        }
        this.currentGameIndex = gameIndex;
        this.currentGameExpanded = game;
        this.currentGameExpandedIndex = game.gameIndex;

        setTimeout(() => {
          collapseElement = document.getElementById(`game-${gameIndex}`);
          if (collapseElement) {
            collapseElement.scrollIntoView(true);
          }
        }, 300);
      }
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setPlaylistIndex', 'setIsModalCreatePlayListOpen']),
    ...mapMutations('mediaGeneral', ['setPlaysToSaveAsFavorites']),
    ...mapMutations(['setIsSectionLoading']),
    // todo: verify time with values over 100
    async confirmModalPlaylistConfirm() {
      try {
        if (this.playIdToDelete && this.playlistId) {
          this.setIsSectionLoading(true);
          await axios.put(`https://r6d08waisc.execute-api.us-east-2.amazonaws.com/prod/users/playlists/videos`, {
            user_id: this.user.id,
            playlist_id: this.playlistId,
            videos: [this.playIdToDelete],
          });
          const videoIndex = this.currentPlayerQueue.findIndex(play => play.playId === this.playIdToDelete);
          const videoIndex2 = this.playlist.plays.findIndex(play => play[playIndex.playId] === this.playIdToDelete);
          if (videoIndex !== -1) {
            this.currentPlayerQueue.splice(videoIndex, 1);
            if (videoIndex === this.playlistIndex) {
              const nextVideoIndex = videoIndex + 1;
              this.setPlaylistIndex({
                mediaPlayerType: null,
                playlistIndex: nextVideoIndex < this.currentPlayerQueue.length - 1 ? nextVideoIndex : 0,
              });
            }
          }
          if (videoIndex2 !== -1) {
            this.playlist.plays.splice(videoIndex2, 1);
          }
        }
        this.showSuccess();
      } catch (e) {
        throw new Error(e);
      } finally {
        this.setIsSectionLoading(false);
      }
    },
    showSuccess() {
      this.$buefy.notification.open({
        message: 'El video se elimino correctamente.',
        type: 'is-success',
      });
    },
    closeModalPlaylistConfirm() {
      this.showConfirmPlaylist = false;
    },
    openConfirmDelete(play) {
      this.playIdToDelete = play.playId;
      this.showConfirmPlaylist = true;
    },
    openAddPlayList(play) {
      this.setPlaysToSaveAsFavorites([play.playRaw]);
      this.setIsModalCreatePlayListOpen(true);
    },
    getStartMinutes(minutesString = '000:00') {
      if (minutesString.startsWith('0')) {
        return minutesString.slice(1);
      }
      return minutesString;
    },
    getGeneralName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word, index) => {
          if (index === 0) {
            if (word.includes('.')) {
              accumulator.push(word);
            } else {
              const wordAux = word.toLowerCase().split('');
              wordAux[0] = wordAux[0].toUpperCase();
              accumulator.push(wordAux.join(''));
            }
          } else {
            accumulator.push(word.toLowerCase());
          }
          return accumulator;
        }, [])
        .join(' ');
    },
    getSingleName(categoryName) {
      const categoryNameArray = categoryName.split(' ');
      return categoryNameArray
        .reduce((accumulator, word) => {
          let wordAux = word;
          if (word.endsWith('minaron')) {
            wordAux = word.replace('minaron', 'minó');
          } else if (word.endsWith('vocan')) {
            wordAux = word.replace('vocan', 'voca');
          } else if (word.endsWith('lones')) {
            wordAux = word.replace('lones', 'lón');
          } else if (word.endsWith('oles')) {
            wordAux = word.replace('oles', 'ol');
          } else if (word.endsWith('os') || word.endsWith('as') || word.endsWith('es')) {
            wordAux = word.slice(0, word.length - 1);
          }
          accumulator.push(wordAux);
          return accumulator;
        }, [])
        .join(' ');
    },
    getCategoryFormat(categoryName = '') {
      const generalName = this.getGeneralName(categoryName);
      return this.getSingleName(generalName);
    },
    onGameOpen(game, index) {
      this.currentGameIndex = index;
      this.currentGameExpanded = game;
      this.currentGameExpandedIndex = game.gameIndex;
    },
    onGameClose() {
      this.currentGameExpanded = null;
      this.currentGameExpandedIndex = -1;
    },
    onClickBack() {
      this.$emit('back');
    },
    onPlayClick(playIndex) {
      if (playIndex !== this.playlistIndex) {
        this.setPlaylistIndex({ mediaPlayerType: null, playlistIndex: playIndex });
      }
      EventBus.$emit('play-video', true);
    },
  },
};
</script>

<style scoped lang="scss">
$blue: #132839;
$green: #cbee6b;

.playlist {
  font-size: 1rem;
  width: 100%;
  height: 100%;
  //max-height: 390px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-family: Avenir-Demi, sans-serif;

  &__title {
    width: 100%;
    font-size: 1.625em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.85;
    letter-spacing: -0.52px;
    text-align: left;
    color: $blue;
    padding: 0.6em 0;
  }

  &__header {
    display: grid;
    grid-template-columns: 51% min-content 1fr;
    padding: 0.6em 0 0.3em;
    border-radius: 6px;
    background-color: $blue;
    text-transform: uppercase;
    font-size: 0.6875em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: 0.44px;
    text-align: center;
    color: #bbd0e1;

    & > div {
      justify-self: flex-start;

      &:first-child {
        padding-left: 20%;
      }

      &:last-child {
        padding-left: 15%;
      }
    }
  }

  &__games {
    height: 100%;
    margin-top: 0.5em;
    max-height: calc(100vh - 480px);
    overflow: auto;

    &__game-header {
      border-radius: 6px;
      border: solid 1px #dbe5ee;
      background-color: #f4f6f9;
      margin: 0.2em;

      &.game-active {
        padding: 0.1em;
        background-color: white;

        & .playlist__games__game-header__content {
          border-radius: 6px;
          background-color: #e4fca5;
        }
      }

      &__content {
        display: grid;
        grid-template-columns: 11% 40% 5.5em 1fr;
        font-size: 0.875em;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: -0.28px;
        text-align: left;
        padding: 0.8em 0 0.6em;

        & > div {
          align-self: center;

          &.icon {
            padding-left: 0;
            width: 100%;
            justify-self: flex-start;

            & img {
              height: 24px;
              width: 24px;
            }
          }

          &.teams {
            text-transform: uppercase;
            & > span.vs {
              font-size: 0.85em;
              font-weight: 500;
            }
          }

          &.score {
            white-space: nowrap;
            justify-self: center;
          }

          &.date {
            margin-left: 1.2em;
          }
        }
      }
    }

    &__game {
      &__plays {
        padding: 0 0.2em;
        &__play {
          display: grid;
          grid-template-columns: min-content min-content 1fr min-content;
          font-family: Avenir-Demi-Medium, sans-serif;
          font-size: 0.875em;
          padding: 0.6153em 0;
          cursor: pointer;

          &:nth-child(1n + 1) {
            border-top: 1px dashed #d1e0ea;
          }

          & > div {
            justify-self: left;
          }

          & .play-icon {
            height: 20px;
            width: 20px;
            margin: 0 25px;
            & img {
              height: 20px;
              width: 20px;
            }
          }

          & .play-time-start {
            margin: 0 1em 0 0;
          }

          & .play-info {
            text-align: left;
          }

          & .play-is-favorite {
            height: 20px;
            width: 20px;
            margin: 0 1em;
            & img {
              height: 20px;
              width: 20px;
            }
          }

          &.active {
            color: #7caa0a;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1550px) {
    &__games {
      max-height: 480px;
    }
  }

  @media screen and (max-width: 1420px) {
    &__games {
      max-height: 415px;
    }
  }

  @media screen and (max-width: 690px) {
    &__games {
      max-height: 310px;
    }
  }

  @media screen and (min-width: 600px) {
    &__back {
      display: none;
    }
  }

  @media screen and (max-width: 480px) {
    padding: 1em 0.1em;

    &__back {
      margin-left: 0.5em;
    }

    &__title {
      width: 100%;
      text-align: center;
    }

    &__header {
      grid-template-columns: 42% min-content 1fr;
    }

    &__games {
      &__game-header {
        &__content {
          grid-template-columns: 11% 30% 5.5em 1fr;
          & > div {
            font-size: 0.9285em;

            &.icon {
              padding-left: 0;
              width: 100%;
              justify-self: flex-start;

              & img {
                height: 24px;
                width: 24px;
              }
            }

            &.teams {
              & > span.vs {
                font-size: 0.85em;
                font-weight: 500;
              }
            }

            &.date {
              margin-left: 1em;
            }
          }
        }
      }

      &__game {
        &__plays {
          &__play {
            display: grid;
            grid-template-columns: min-content min-content 1fr min-content;

            & .play-icon {
              margin: 0 5px;
            }
          }
        }
      }
    }
  }
}
</style>
